import {
  ROLE_APPOINTMENT,
  ROLE_ASSESSMENT,
  ROLE_BLOOD_TEST,
  ROLE_BLOOD_TEST_BLOOD_GROUPING,
  ROLE_BLOOD_TEST_SEROLOGY,
  ROLE_COLLECTIONS,
  ROLE_COMPONENT_SEPARATION,
  ROLE_COMPONENT_TRANSFORMATION,
  ROLE_CONTROL_PANEL,
  ROLE_DONORS,
  ROLE_EQUIPMENT,
  ROLE_INVENTORY,
  ROLE_LABELING,
  ROLE_PRODUCTION,
  ROLE_VITAL_SIGNS,
  ROLE_REQUEST,
  ROLE_NOMINATIVE_REQUEST,
  ROLE_DISTRIBUTION,
  ROLE_PRODUCTION_PRODUCT_REJECTED,
  ROLE_PRODUCTION_RECEPTION,
  ROLE_PATIENT,
  ROLE_PATIENT_LAB_RESULT,
  ROLE_ACCOUNT,
  ROLE_RETURN,
  ROLE_ACCOUNT_INVENTORY_SWITCHING,
  ROLE_RECEPTION,
  ROLE_COLLECTION_TYPE,
  ROLE_TEST_ASSAY_RULE,
  ROLE_OVERRIDE_SEROLOGY_ALINITY_TEST_RESULT,
} from "../../constants/ROLES";
import { defineRole } from "../handleAccessRoles";

const accessMenu = () => {
  const userInfo = JSON.parse(localStorage.getItem("RBBMS"));

  const user = userInfo ? userInfo : {};

  const canReadDonorDemography = defineRole({
    roles: user.accessRole,
    menu: ROLE_DONORS,
    operation: "demography",
  });

  const canReadPreAssessment = defineRole({
    roles: user.accessRole,
    menu: ROLE_ASSESSMENT,
    operation: "read",
  });

  //blood testing
  const canReadBloodTest = defineRole({
    roles: user.accessRole,
    menu: ROLE_BLOOD_TEST,
    operation: "read",
  });

  const canUpdateBloodTest = defineRole({
    roles: user.accessRole,
    menu: ROLE_BLOOD_TEST,
    operation: "update",
  });

  const canDeleteBloodTest = defineRole({
    roles: user.accessRole,
    menu: ROLE_BLOOD_TEST,
    operation: "delete",
  });

  //assessments
  const canReadAssessment = defineRole({
    roles: user.accessRole,
    menu: ROLE_ASSESSMENT,
    operation: "read",
    pass: user.role === "donor" || user.account_type === "donor",
  });

  const canUpdateAssessment = defineRole({
    roles: user.accessRole,
    menu: ROLE_ASSESSMENT,
    operation: "update",
    pass: user.role === "donor" || user.account_type === "donor",
  });

  const canDeleteAssessment = defineRole({
    roles: user.accessRole,
    menu: ROLE_ASSESSMENT,
    operation: "delete",
  });

  const canCreateAssessment = defineRole({
    roles: user.accessRole,
    menu: ROLE_ASSESSMENT,
    operation: "create",
    pass: user.role === "donor" || user.account_type === "donor",
  });

  // vital signs
  const canReadVital = defineRole({
    roles: user.accessRole,
    menu: ROLE_VITAL_SIGNS,
    operation: "read",
  });

  const canCreateVital = defineRole({
    roles: user.accessRole,
    menu: ROLE_VITAL_SIGNS,
    operation: "create",
  });

  const canUpdateVital = defineRole({
    roles: user.accessRole,
    menu: ROLE_VITAL_SIGNS,
    operation: "update",
  });

  const canDeleteVital = defineRole({
    roles: user.accessRole,
    menu: ROLE_VITAL_SIGNS,
    operation: "delete",
  });

  // appointments

  const canReadAppointment = defineRole({
    roles: user.accessRole,
    menu: ROLE_APPOINTMENT,
    operation: "read",
  });

  const canUpdateAppointment = defineRole({
    roles: user.accessRole,
    menu: ROLE_APPOINTMENT,
    operation: "update",
  });

  const canDeleteAppointment = defineRole({
    roles: user.accessRole,
    menu: ROLE_APPOINTMENT,
    operation: "delete",
  });

  const canCreateAppointment = defineRole({
    roles: user.accessRole,
    menu: ROLE_APPOINTMENT,
    operation: "create",
  });

  // collections

  const canUpdateCollection = defineRole({
    roles: user.accessRole,
    menu: ROLE_COLLECTIONS,
    operation: "update",
  });

  const canDeleteCollection = defineRole({
    roles: user.accessRole,
    menu: ROLE_COLLECTIONS,
    operation: "delete",
  });

  const canCreateCollection = defineRole({
    roles: user.accessRole,
    menu: ROLE_COLLECTIONS,
    operation: "create",
  });

  const canReadCollection = defineRole({
    roles: user.accessRole,
    menu: ROLE_COLLECTIONS,
    operation: "read",
  });

  // blood test
  const canCreateBloodTestBloodGrouping = defineRole({
    roles: user.accessRole,
    menu: ROLE_BLOOD_TEST_BLOOD_GROUPING,
    operation: "create",
  });

  const canUpdateBloodTestBloodGrouping = defineRole({
    roles: user.accessRole,
    menu: ROLE_BLOOD_TEST_BLOOD_GROUPING,
    operation: "update",
  });

  const canConfirmBloodTestBloodGrouping = defineRole({
    roles: user.accessRole,
    menu: ROLE_BLOOD_TEST_BLOOD_GROUPING,
    operation: "confirm",
  });

  //serology

  const canCreateBloodTestSerology = defineRole({
    roles: user.accessRole,
    menu: ROLE_BLOOD_TEST_SEROLOGY,
    operation: "create",
  });

  const canUpdateBloodTestSerology = defineRole({
    roles: user.accessRole,
    menu: ROLE_BLOOD_TEST_SEROLOGY,
    operation: "update",
  });

  const canConfirmBloodTestSerology = defineRole({
    roles: user.accessRole,
    menu: ROLE_BLOOD_TEST_SEROLOGY,
    operation: "confirm",
  });

  const canSerologyOverrideAlinityTestRes = defineRole({
    roles: user.accessRole,
    menu: ROLE_OVERRIDE_SEROLOGY_ALINITY_TEST_RESULT,
    operation: "update",
  });

  //production
  const canReadProductionInventory = defineRole({
    roles: user.accessRole,
    menu: ROLE_INVENTORY,
    operation: "read",
  });

  // true only for users with ROLE_PRODUCTION — used to show the Inventory tab
  // inside Component Production (distinct from the main Inventory module access)
  const canReadProductionSection = defineRole({
    roles: user.accessRole,
    menu: ROLE_PRODUCTION,
    operation: "read",
  });

  const canReadComponentSeparation = defineRole({
    roles: user.accessRole,
    menu: ROLE_COMPONENT_SEPARATION,
    operation: "read",
  });

  const canReadComponentTransformation = defineRole({
    roles: user.accessRole,
    menu: ROLE_COMPONENT_TRANSFORMATION,
    operation: "read",
  });

  const canReadLabeling = defineRole({
    roles: user.accessRole,
    menu: ROLE_LABELING,
    operation: "read",
  });

  const canReadProductionRejectedProduct = defineRole({
    roles: user.accessRole,
    menu: ROLE_PRODUCTION_PRODUCT_REJECTED,
    operation: "read",
  });

  //Equipment
  const canReadEquipment = defineRole({
    roles: user.accessRole,
    menu: ROLE_EQUIPMENT,
    operation: "read",
  });

  const canCreateEquipment = defineRole({
    roles: user.accessRole,
    menu: ROLE_EQUIPMENT,
    operation: "create",
  });

  const canDeleteEquipment = defineRole({
    roles: user.accessRole,
    menu: ROLE_EQUIPMENT,
    operation: "delete",
  });

  const canUpdateEquipment = defineRole({
    roles: user.accessRole,
    menu: ROLE_EQUIPMENT,
    operation: "update",
  });

  //Control Panel
  const canPanelCreateEquipment = defineRole({
    roles: user.accessRole,
    menu: ROLE_CONTROL_PANEL,
    operation: "createEquipment",
  });

  const canPanelCreateCollectionType = defineRole({
    roles: user.accessRole,
    menu: ROLE_COLLECTION_TYPE,
    operation: "createCollectionType",
  });

  const canPanelCreateVitalSign = defineRole({
    roles: user.accessRole,
    menu: ROLE_CONTROL_PANEL,
    operation: "createVitalSign",
  });

  const canPanelCreateAccessRoles = defineRole({
    roles: user.accessRole,
    menu: ROLE_CONTROL_PANEL,
    operation: "createAccessRoles",
  });

  const canPanelCreateBloodTestQuestionnaire = defineRole({
    roles: user.accessRole,
    menu: ROLE_CONTROL_PANEL,
    operation: "createBloodTestingQuestionnaire",
  });

  const canPanelCreateComponentProfile = defineRole({
    roles: user.accessRole,
    menu: ROLE_CONTROL_PANEL,
    operation: "createComponentProfile",
  });

  const canPanelCreateMeasures = defineRole({
    roles: user.accessRole,
    menu: ROLE_CONTROL_PANEL,
    operation: "createMeasures",
  });

  const canPanelGeneralAccess = defineRole({
    roles: user.accessRole,
    menu: ROLE_CONTROL_PANEL,
    operation: "general",
  });

  // Test Assay Rules
  const canPanelCreateTestAssayRule = defineRole({
    roles: user.accessRole,
    menu: ROLE_CONTROL_PANEL,
    operation: "createTestAssayRule",
  });

  //REQUEST

  const canReadBloodRequestAccess = defineRole({
    roles: user.accessRole,
    menu: [ROLE_REQUEST, ROLE_NOMINATIVE_REQUEST],
    operation: "read",
  });

  const canDeleteBloodRequestAccess = defineRole({
    roles: user.accessRole,
    menu: ROLE_REQUEST,
    operation: "delete",
  });

  const canUpdateBloodRequestAccess = defineRole({
    roles: user.accessRole,
    menu: ROLE_REQUEST,
    operation: "update",
  });

  const canBloodBankReceiveBloodRequestAccess = defineRole({
    roles: user.accessRole,
    menu: ROLE_REQUEST,
    operation: "bloodBankPreparation",
  });

  const canDistributorReceiveBloodRequestAccess = defineRole({
    roles: user.accessRole,
    menu: ROLE_REQUEST,
    operation: "distributorReceive",
  });

  const canHospitalReceiveBloodRequestAccess = defineRole({
    roles: user.accessRole,
    menu: ROLE_REQUEST,
    operation: "hospitalReception",
  });

  const canCreateBloodRequestAccess = defineRole({
    roles: user.accessRole,
    menu: ROLE_REQUEST,
    operation: "create",
  });

  const canCreateShipmentAccess = defineRole({
    roles: user.accessRole,
    menu: ROLE_DISTRIBUTION,
    operation: "create",
  });

  const canReadProductionReception = defineRole({
    roles: user.accessRole,
    menu: ROLE_PRODUCTION_RECEPTION,
    operation: "create",
  });

// eslint-disable-next-line no-unused-vars
  const canCreatePatient = defineRole({
    roles: user.accessRole,
    menu: ROLE_PATIENT,
    operation: "create",
  });

  const canReadPatient = defineRole({
    roles: user.accessRole,
    menu: ROLE_PATIENT,
    operation: "read",
  });

  const canUpdatePatient = defineRole({
    roles: user.accessRole,
    menu: ROLE_PATIENT,
    operation: "update",
  });

  const canDeletePatient = defineRole({
    roles: user.accessRole,
    menu: ROLE_PATIENT,
    operation: "delete",
  });

  const canReadPatientLabResult = defineRole({
    roles: user.accessRole,
    menu: ROLE_PATIENT_LAB_RESULT,
    operation: "read",
  });

  const canCreatePatientLabResult = defineRole({
    roles: user.accessRole,
    menu: ROLE_PATIENT_LAB_RESULT,
    operation: "create",
  });

  const canUpdatePatientLabResult = defineRole({
    roles: user.accessRole,
    menu: ROLE_PATIENT_LAB_RESULT,
    operation: "update",
  });

  const canReadAccount = defineRole({
    roles: user.accessRole,
    menu: ROLE_ACCOUNT,
    operation: "read",
  });

  const canUpdateAccount = defineRole({
    roles: user.accessRole,
    menu: ROLE_ACCOUNT,
    operation: "update",
  });

  const canDeleteAccount = defineRole({
    roles: user.accessRole,
    menu: ROLE_ACCOUNT,
    operation: "delete",
  });

  const canPostReturn = defineRole({
    roles: user.accessRole,
    menu: ROLE_RETURN,
    operation: "create",
  });

  const canUpdateReturn = defineRole({
    roles: user.accessRole,
    menu: ROLE_RETURN,
    operation: "update",
  });

  const canDeleteReturn = defineRole({
    roles: user.accessRole,
    menu: ROLE_RETURN,
    operation: "delete",
  });

  const canReadReturn = defineRole({
    roles: user.accessRole,
    menu: ROLE_RETURN,
    operation: "read",
  });

  const canSwitchInventory = defineRole({
    roles: user.accessRole,
    menu: ROLE_ACCOUNT_INVENTORY_SWITCHING,
    operation: "read",
  });

  const canReceive = defineRole({
    roles: user.accessRole,
    menu: ROLE_RECEPTION,
    operation: "create",
  });

  const canReadReception = defineRole({
    roles: user.accessRole,
    menu: ROLE_RECEPTION,
    operation: "read",
  });

  const canPanelCreateAlinityAssayRule = defineRole({
    roles: user.accessRole,
    menu: ROLE_TEST_ASSAY_RULE,
    operation: "create",
  });

  const canPanelUpdateAlinityAssayRule = defineRole({
    roles: user.accessRole,
    menu: ROLE_TEST_ASSAY_RULE,
    operation: "update",
  });

  const canPanelDeleteAlinityAssayRule = defineRole({
    roles: user.accessRole,
    menu: ROLE_TEST_ASSAY_RULE,
    operation: "delete",
  });

  return {
    canReadAppointment,
    canReadPreAssessment,
    canReadCollection,
    canReadVital,
    canReadDonorDemography,
    canReadBloodTest,
    canDeleteAssessment,
    canReadAssessment,
    canUpdateAssessment,
    canCreateAssessment,
    canCreateCollection,
    canDeleteCollection,
    canUpdateCollection,
    canCreateAppointment,
    canDeleteAppointment,
    canUpdateAppointment,
    canDeleteVital,
    canUpdateVital,
    canCreateVital,
    canCreateBloodTestBloodGrouping,
    canConfirmBloodTestBloodGrouping,
    canUpdateBloodTestBloodGrouping,
    canReadComponentTransformation,
    canReadComponentSeparation,
    canReadProductionInventory,
    canReadProductionSection,
    canReadLabeling,
    canReadEquipment,
    canUpdateEquipment,
    canDeleteEquipment,
    canCreateEquipment,
    canPanelCreateComponentProfile,
    canPanelCreateBloodTestQuestionnaire,
    canPanelCreateAccessRoles,
    canPanelCreateVitalSign,
    canPanelCreateCollectionType,
    canPanelCreateEquipment,
    canPanelCreateMeasures,
    canPanelGeneralAccess,
    canPanelCreateTestAssayRule,
    canConfirmBloodTestSerology,
    canCreateBloodTestSerology,
    canUpdateBloodTestSerology,
    canReadBloodRequestAccess,
    canDeleteBloodRequestAccess,
    canUpdateBloodRequestAccess,
    canCreateBloodRequestAccess,
    canDistributorReceiveBloodRequestAccess,
    canHospitalReceiveBloodRequestAccess,
    canBloodBankReceiveBloodRequestAccess,
    canUpdateBloodTest,
    canDeleteBloodTest,
    canCreateShipmentAccess,
    canReadProductionRejectedProduct,
    canReadProductionReception,
    canReadPatient,
    canReadPatientLabResult,
    canDeletePatient,
    canUpdatePatient,
    canCreatePatientLabResult,
    canUpdatePatientLabResult,
    canReadAccount,
    canUpdateAccount,
    canDeleteAccount,
    canPostReturn,
    canReadReturn,
    canUpdateReturn,
    canDeleteReturn,
    canSwitchInventory,
    canReceive,
    canReadReception,
    canPanelCreateAlinityAssayRule,
    canPanelUpdateAlinityAssayRule,
    canPanelDeleteAlinityAssayRule,
    canSerologyOverrideAlinityTestRes,
  };
};

export default accessMenu;
